import React, { useState } from 'react';
import * as moment from 'moment';
import { convertToCSVFormat, generateRatio } from '../../../utils';
import CardABversion from './CardABversion';
import FailedDeliveryReport from '../../MessageAnalytics/Components/FailedDeliveryReport';
import { DeliveryRateIcon, BounceRateIcon } from '../../SVGs/Icons';

const Text = ({
  isLoadingData,
  message,
  startDate,
  textEvents,
  isDataAvailable,
  setDeliveryActivityVisibility,
}) => {
  const [isBounceDrawerVisible, setBounceDrawerVisibility] = useState(false);
  const [data, setData] = useState([]);
  const [csvData, setCSVData] = useState([]);

  const handleDeliveryRateClick = () => {
    setDeliveryActivityVisibility(true, 'text');
  };

  const handleTextBounceRateClick = () => {
    const dataVersionA = textEvents.bounceEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.phone,
    }));

    const dataVersionB = textEvents.versionB.bounceEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.phone,
    }));

    const data = [...dataVersionA, ...dataVersionB];

    setData(data);
    setCSVData(convertToCSVFormat(data));
    setBounceDrawerVisibility(true);
  };

  return (
    <>
      <CardABversion
        name="Delivery Rate Average"
        valueARatio={generateRatio(textEvents.delivered, textEvents.sent)}
        valueBRatio={generateRatio(
          textEvents.versionB.delivered,
          textEvents.versionB.sent
        )}
        valueACount={textEvents.delivered}
        valueBCount={textEvents.versionB.delivered}
        title="The % of members successfully delivered to (Delivered / Recipients)"
        onClick={message ? handleDeliveryRateClick : null}
        isDataAvailable={isDataAvailable}
        messageStatus={message?.status}
        Icon={DeliveryRateIcon}
      />
      <CardABversion
        name="Bounce Rate Average"
        valueARatio={generateRatio(textEvents.bounced, textEvents.sent)}
        valueBRatio={generateRatio(
          textEvents.versionB.bounced,
          textEvents.versionB.sent
        )}
        valueACount={textEvents.bounced}
        valueBCount={textEvents.versionB.bounced}
        title="Usually a result of sending to a bad phone number."
        onClick={handleTextBounceRateClick}
        isDataAvailable={isDataAvailable}
        messageStatus={message?.status}
        Icon={BounceRateIcon}
      />
      <FailedDeliveryReport
        onCloseDrawer={() => setBounceDrawerVisibility(false)}
        isVisible={isBounceDrawerVisible}
        isLoading={isLoadingData}
        message={message}
        startDate={startDate}
        data={data}
        csvData={csvData}
      />
    </>
  );
};

export default Text;
